/* Ic3y — Listening Archive behaviour: sorting, filters, rating dialog */
(function () {
  function init(root) {
    root = root || document;

    // newest first (sessions carry a unix timestamp in data-ts)
    root.querySelectorAll('[data-la-sort]').forEach(function (list) {
      Array.from(list.children)
        .sort(function (a, b) { return (+b.dataset.ts || 0) - (+a.dataset.ts || 0); })
        .forEach(function (el) { list.appendChild(el); });
    });

    // filter chips: data-la-filter="state|format" on the chip row, data-value on each chip
    root.querySelectorAll('[data-la-filter]').forEach(function (row) {
      if (row.dataset.bound) return; row.dataset.bound = '1';
      var key = row.dataset.laFilter;
      var target = document.querySelector(row.dataset.target);
      row.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-value]'); if (!chip || !target) return;
        row.querySelectorAll('[data-value]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        var v = chip.dataset.value;
        Array.from(target.children).forEach(function (el) {
          var val = (el.dataset[key] || '').toLowerCase();
          el.hidden = !(v === 'all' || (' ' + val).indexOf(' ' + v) > -1);
        });
      });
    });

    // my tickets (QR codes come from the Ic3y app)
    var tbox = root.querySelector('[data-la-tickets]');
    if (tbox && !tbox.dataset.bound) {
      tbox.dataset.bound = '1';
      var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      fetch('/apps/ic3y/tickets', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
        var grid = tbox.querySelector('[data-la-tix]');
        var ld = grid.querySelector('[data-la-tix-loading]'); if (ld) ld.remove();
        // upcoming only: drop tickets whose date has passed (today still shows)
        var today = new Date(); today.setHours(0, 0, 0, 0);
        var MON = { jan: 0, feb: 1, fev: 1, mar: 2, apr: 3, avr: 3, may: 4, mai: 4, jun: 5, juin: 5, jul: 6, juil: 6, aug: 7, aou: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
        var parse = function (s) {
          s = String(s || '').split('·')[0].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
          if (!s) return null;
          var iso = s.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
          if (iso) return new Date(+iso[1], +iso[2] - 1, +iso[3]);
          var m = null, k; for (k in MON) { if (new RegExp('\\b' + k).test(s)) { m = MON[k]; break; } }
          var day = (s.match(/\b(\d{1,2})(st|nd|rd|th|er)?\b/) || [])[1];
          var yr = (s.match(/\b(20\d{2})\b/) || [])[1] || today.getFullYear();
          if (m === null || !day) return null;
          return new Date(+yr, m, +day);
        };
        var list = (d.ok ? d.tickets : []).filter(function (t) {
          var when = parse(t.when) || parse(t.date);
          return !when || when >= today;
        });
        if (!list.length) { grid.innerHTML = '<p class="la-empty">' + esc(tbox.dataset.empty || 'No upcoming tickets.') + '</p>'; return; }
        d.tickets = list;
        d.tickets.sort(function (a, b) { return (a.checkedIn ? 1 : 0) - (b.checkedIn ? 1 : 0); }).forEach(function (t) {
          var url = location.origin + '/apps/ic3y/check?t=' + encodeURIComponent(t.token);
          var svg = '';
          if (window.qrcode) { var q = window.qrcode(0, 'M'); q.addData(url); q.make(); svg = q.createSvgTag({ cellSize: 6, margin: 0, scalable: true }); }
          var el = document.createElement('article');
          el.className = 'la-tix__card' + (t.checkedIn ? ' is-used' : '');
          el.innerHTML = '<div class="la-tix__top">' + (t.image ? '<img class="la-tix__img" src="' + esc(t.image) + '&width=120" alt="">' : '') +
            '<div style="min-width:0"><div class="la-mono">' + esc(t.date) + '</div><div class="la-tix__ev">' + esc(t.event) + '</div></div></div>' +
            '<div class="la-tix__qr">' + (t.checkedIn ? '<span class="la-mono" style="color:#0a0a0a;padding:60px 0">checked in · ' + esc(t.checkedIn) + '</span>' : svg) + '</div>' +
            '<div class="la-tix__row"><span class="la-tix__seat">' + esc(t.seat) + '</span><span class="la-mono">' + esc(t.admits) + ' · ' + esc(t.order) + '</span></div>';
          grid.appendChild(el);
        });
      }).catch(function () { var g = tbox.querySelector('[data-la-tix]'); if (g) g.innerHTML = '<p class="la-empty">could not load tickets — refresh the page.</p>'; });
    }

    var dlg = document.querySelector('[data-la-rate]');
    if (!dlg || dlg.dataset.bound) return; dlg.dataset.bound = '1';
    if (typeof dlg.showModal !== 'function') { dlg.showModal = function () { dlg.setAttribute('open', ''); }; dlg.close = function () { dlg.removeAttribute('open'); }; }

    var step = parseFloat(dlg.dataset.step) || 0.1;
    var minNote = parseInt(dlg.dataset.noteMin, 10) || 40;
    var endpoint = dlg.dataset.endpoint || '';
    var num = dlg.querySelector('[data-la-num]');
    var out = dlg.querySelector('[data-la-value]');
    var fill = dlg.querySelector('.la-track__fill');
    var knob = dlg.querySelector('.la-track__knob');
    var track = dlg.querySelector('.la-track');
    var note = dlg.querySelector('textarea');
    var count = dlg.querySelector('[data-la-count]');
    var earn = dlg.querySelector('[data-la-earn]');
    var form = dlg.querySelector('form');
    var st = { score: 7.5, editing: false, cur: {} };

    function r(v) { return Math.round(Math.min(10, Math.max(0, v)) / step) * step; }
    function set(name, v) { var el = form && form.querySelector('[name="' + name + '"]'); if (el) el.value = v; }
    function paint() {
      var s = st.score.toFixed(1);
      out.textContent = s;
      out.classList.toggle('is-high', st.score >= 9);
      num.setAttribute('aria-valuenow', s);
      fill.style.width = knob.style.left = (st.score * 10) + '%';
      count.textContent = note.value.length;
      var long = note.value.trim().length >= minNote;
      earn.textContent = st.editing ? 'editing your take — no extra credits for changes'
        : '+' + dlg.dataset.earnRate + ' for scoring the album' + (long ? ' · +' + dlg.dataset.earnNote + ' for your take' : ' · +' + dlg.dataset.earnNote + ' with a note of ' + minNote + '+ characters');
      set('score', s);
      set('contact[body]', 'LISTENING RATING\nsession: ' + (st.cur.handle || '') + '\nalbum: ' + (st.cur.album || '') + '\nscore: ' + s + '\nnote: ' + note.value);
    }

    window.IC3Y_openRate = function (b) {
      st.cur = { handle: b.dataset.handle, album: b.dataset.album };
      st.editing = !!b.dataset.score;
      st.score = st.editing ? parseFloat(b.dataset.score) : 7.5;
      note.value = b.dataset.note || '';
      dlg.querySelector('[data-la-artist]').textContent = b.dataset.artist || '';
      dlg.querySelector('[data-la-album]').textContent = b.dataset.album || '';
      dlg.querySelector('[data-la-kicker]').textContent = b.dataset.kicker || '';
      set('session', b.dataset.handle);
      var sb = form.querySelector('[type=submit]'); if (sb) sb.textContent = st.editing ? 'update my take' : 'share my take';
      paint();
      dlg.showModal();
      var cur = document.getElementById('ic3y-cursor'); if (cur) dlg.appendChild(cur);
      num.focus();
    };
    dlg.querySelector('[data-la-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('close', function () { var cur = document.getElementById('ic3y-cursor'); if (cur) document.body.appendChild(cur); });

    var drag = null;
    num.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, v: st.score }; if (num.setPointerCapture) num.setPointerCapture(e.pointerId); });
    num.addEventListener('pointermove', function (e) { if (!drag) return; st.score = r(drag.v + (e.clientX - drag.x) / 12 * 0.1); paint(); });
    ['pointerup', 'pointercancel'].forEach(function (t) { num.addEventListener(t, function () { drag = null; }); });
    num.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); st.score = r(st.score + step); paint(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); st.score = r(st.score - step); paint(); }
    });
    track.addEventListener('click', function (e) { var bb = track.getBoundingClientRect(); st.score = r((e.clientX - bb.left) / bb.width * 10); paint(); });
    note.addEventListener('input', paint);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sb = form.querySelector('[type=submit]');
      sb.disabled = true; sb.textContent = 'saving…';
      fetch(endpoint || '/apps/ic3y/rate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ session: st.cur.handle, score: st.score, note: note.value }) })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok || !d.ok) throw new Error(d.error || res.status); return d; }); })
        .then(function () { location.reload(); })
        .catch(function (err) { sb.disabled = false; sb.textContent = st.editing ? 'update my take' : 'share my take'; earn.textContent = 'could not save — ' + err.message; });
    });
  }

  // one delegated listener for every "rate this listening" / "edit your note" button
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-la-open]'); if (!b) return;
    e.preventDefault();
    init();
    if (window.IC3Y_openRate) window.IC3Y_openRate(b);
  });
  window.IC3Y_bootArchive = function () { init(); deepRate(); };

  // QR on screen at the end of a session → /pages/my-archive?rate=<session-handle>
  // remembered across the login redirect, then opens that album's score popup
  function deepRate() {
    try {
      var q = new URLSearchParams(location.search).get('rate');
      if (q) sessionStorage.setItem('ic3y_rate', q);
      var h = q || sessionStorage.getItem('ic3y_rate'); if (!h) return;
      var b = document.querySelector('[data-la-open][data-handle="' + h.replace(/"/g, '') + '"]');
      // staff link from past events: album not in the archive lists → build the popup trigger from the link
      var sp = new URLSearchParams(location.search);
      if (!b && sp.get('album') && document.querySelector('[data-la-rate]')) {
        b = document.createElement('button'); b.type = 'button'; b.hidden = true; b.setAttribute('data-la-open', '');
        b.setAttribute('data-handle', h); b.setAttribute('data-album', sp.get('album') || '');
        b.setAttribute('data-artist', sp.get('artist') || ''); b.setAttribute('data-kicker', sp.get('kicker') || '');
        document.body.appendChild(b);
      }
      if (!b) return;
      sessionStorage.removeItem('ic3y_rate');
      if (q && history.replaceState) history.replaceState(null, '', location.pathname);
      init();
      if (window.IC3Y_openRate) window.IC3Y_openRate(b); else b.click();
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deepRate); else deepRate();
  window.IC3Y_deepRate = deepRate;

  // redeem a reward → code is created, credits deducted, code applied to the cart
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-la-redeem]'); if (!b || b.disabled) return;
    e.preventDefault();
    if (!confirm('Redeem ' + b.dataset.cost + ' credits for: ' + b.dataset.name + '?')) return;
    var msg = b.parentNode.querySelector('[data-la-redeem-msg]');
    b.disabled = true; b.textContent = 'creating your code…';
    fetch('/apps/ic3y/redeem', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ reward: b.dataset.laRedeem }) })
      .then(function (res) { return res.json().then(function (d) { if (!res.ok || !d.ok) throw new Error(d.error || res.status); return d; }); })
      .then(function (d) {
        b.textContent = d.code;
        if (msg) msg.textContent = 'applied to your cart · pick your session';
        setTimeout(function () { location.href = '/discount/' + encodeURIComponent(d.code) + '?redirect=/pages/events'; }, 1800);
      })
      .catch(function (err) { b.disabled = false; b.textContent = 'redeem →'; if (msg) msg.textContent = 'could not redeem — ' + err.message; });
  });

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('ic3y:page', function () { init(); });
})();
